import React from 'react';
import './style.scss'
import { Routes, Route } from 'react-router-dom'
import SingleProfile from "./SingleProfile/Index"
// import FourOFour from '../FourOfour/Index'

const Master = () => {

    return (
        <main id="single_profile">

            <Routes>

                <Route path="/:id" element={<SingleProfile />} />

                {/* <Route path="*" element={<FourOFour />} /> */}

            </Routes>

        </main>
    );
};

export default Master;